import React, { useEffect, useState } from 'react';
import './index.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { Select, Tabs, TabsProps, message } from 'antd';
import CockpitGroup from '@/components/CockpitGroup';
import { CockpitMode, CockpitStatus } from '@/utils/type';
import { EventName, ModeOptions, PermissionButton } from '@/utils/constant';
import { CockpitItem } from '@/redux/reducers/newCommon';
import BindVehicleList from '@/components/BindVehicleList';
import { request } from '@/fetch/core';
import { Method } from '@/fetch/core/util';
import { HttpStatusCode } from '@/fetch/core/constant';
import { useNavigate } from 'react-router-dom';
import { sendGlobalEvent } from '@/utils/emit';
import { getPermissionById } from '@/utils/util';
import IssueSummary from '@/components/IssueSummary';
const tabs: TabsProps['items'] = [
  {
    label: '座席团队',
    key: 'COCKPIT_TEAM',
  },
  {
    label: '已绑车辆',
    key: 'BUND_VEHICLE',
  },
];
const Home = () => {
  const navigator = useNavigate();
  const { newCommon, controlBtn, login } = useSelector(
    (state: RootState) => state
  );
  const { teamInfo } = newCommon;
  const { cockpitMode } = newCommon;
  const [selectMode, setSelectMode] = useState<CockpitMode>(cockpitMode);
  const [options, setOptions] = useState<any>([]);
  const [tabKey, setTabKey] = useState<string>(tabs[0].key);
  useEffect(() => {
    const opt: any[] = [];
    ModeOptions.forEach((item) => {
      if (getPermissionById(item.permissionId)) {
        opt.push({
          label: item.label,
          value: item.value,
        });
      }
    });
    setOptions(opt);
    setSelectMode(opt && opt[0]?.value);
  }, [login.userInfo?.resourceList]);
  const formatGroupData = () => {
    let temp: any = {
      workCockpitList: [],
      restCockpitList: [],
      offlineCockpitList: [],
    };
    teamInfo?.cockpitList?.forEach((item: CockpitItem) => {
      if (item.cockpitStatus === CockpitStatus.WORK) {
        temp.workCockpitList.push(item);
      } else if (item.cockpitStatus === CockpitStatus.REST) {
        temp.restCockpitList.push(item);
      } else {
        temp.offlineCockpitList.push(item);
      }
    });
    return temp;
  };

  const enterCockpit = () => {
    request({
      path: '/monitor/web/cockpit/enterCockpit',
      method: Method.POST,
      body: {
        cockpitMode: selectMode,
        cockpitNumber: newCommon.cockpitNumber,
      },
    }).then((res) => {
      if (res.code === HttpStatusCode.Success) {
        sendGlobalEvent(EventName.CREATE_MQTT_CLIENT);
        setTimeout(() => {
          navigator('/app/multivehicle');
        }, 500);
      } else {
        message.error(res.message);
      }
    });
  };

  useEffect(() => {
    if (controlBtn.LC_BUTTON_ENTER) {
      enterCockpit();
    }
  }, [controlBtn.LC_BUTTON_ENTER]);

  useEffect(() => {
    // 减号退出登陆
    if (controlBtn?.LC_BUTTON_MINUS) {
      sendGlobalEvent('LOGIN_OUT');
    }
  }, [controlBtn?.LC_BUTTON_MINUS]);

  return (
    <div className="home-view-container">
      <div className="left-region">
        <IssueSummary />
        <div className="cockpit-status-board">
          <Tabs
            items={tabs}
            defaultActiveKey={tabKey}
            onChange={(tabKey: string) => {
              setTabKey(tabKey);
            }}
          ></Tabs>
          {tabKey === 'COCKPIT_TEAM' ? (
            <CockpitGroup {...formatGroupData()} />
          ) : (
            <BindVehicleList cockpitNumber={newCommon.cockpitNumber} />
          )}
        </div>
      </div>
      <div className="right-region">
        {options.length > 0 && (
          <div className="operate-region">
            <Select
              className="mode-select"
              options={options}
              value={selectMode || (options && options[0]?.value)}
              placement="topLeft"
              onChange={(value: CockpitMode) => {
                setSelectMode(value);
              }}
            />
            <div className="enter-btn" onClick={enterCockpit}>
              按下方向盘回车键进入驾舱
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;
